import { axios } from '@Root/API'

export const getStudentsWithFunding = params => {
	return axios.get('funding-and-monitoring', { params })
}
